<template>
  <div class="mainCommonListContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn"
          >{{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i
        ></el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索型号名称"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="name"
          label="型号名称"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column
        ><el-table-column
          prop="uav_type_name"
          label="无人机类型"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column
        ><el-table-column
          prop="max_weight"
          label="最大起飞重量(kg)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="max_payload"
          label="最大载荷(kg)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="max_fly_range"
          label="最大航程(km)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="start_price"
          label="起步价(万元)"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="cargo_hold_volume"
          label="货舱容积(cm³)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="cargo_hold_length"
          label="货舱长(cm)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="80"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'planeType-view'"
                  @click="view(scope.row)"
                  icon="el-icon-operte-view"
                  class="openBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
                <el-button
                  v-else-if="button.path === 'planeType-edit'"
                  @click="edit(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                ><el-button
                  v-else-if="button.path === 'planeType-del'"
                  @click="del(scope.row)"
                  icon="el-icon-operte-view"
                  class="delBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        ></el-pagination
        ><!-- , jumper -->
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="818px"
      height="717px"
      class="commonScrollDialog"
    >
      <div class="dialog-header-separator"></div>
      <el-form
        :rules="rules"
        ref="commonForm"
        :model="commonForm"
        label-width="270px"
        :disabled="isViewPage"
        @submit.native.prevent
      >
        <div class="scrollContainer" :class="{ isViewPage: isViewPage }">
          <el-form-item prop="name" label="型号名称" class="left-form-item">
            <el-input
              v-model="commonForm.name"
              maxlength="50"
              placeholder="请输入型号名称"
              @keyup.enter.native="submit('commonForm')"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="抗风等级"
            prop="wind_resist_grade"
            class="number-adjust-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('wind_resist_grade')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.wind_resist_grade"
                placeholder="请输入抗风等级"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="2"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('wind_resist_grade')"
              ></el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="最大起飞重量(kg)"
            prop="max_weight"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('max_weight')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.max_weight"
                placeholder="请输入最大起飞重量"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('max_weight')"
              ></el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="分成比例(%)"
            prop="share_proportion"
            class="number-adjust-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('share_proportion')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.share_proportion"
                placeholder="请输入分成比例"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="3"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('share_proportion')"
              ></el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="最大载荷(kg)"
            prop="max_payload"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('max_payload')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.max_payload"
                placeholder="请输入最大载荷"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('max_payload')"
              ></el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="飞机升限(m)"
            prop="uav_ceiling"
            class="number-adjust-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('uav_ceiling')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.uav_ceiling"
                placeholder="请输入飞机升限"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('uav_ceiling')"
              ></el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="起步价(万元)"
            prop="start_price"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('start_price')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.start_price"
                placeholder="请输入起步价"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('start_price')"
              ></el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="最大飞行速度(km/h)"
            prop="max_speed"
            class="number-adjust-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('max_speed')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.max_speed"
                placeholder="请输入最大飞行速度"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('max_speed')"
              ></el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="价格(每50公里/1公斤)"
            prop="price"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('price')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.price"
                placeholder="请输入价格"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="5"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('price')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            label="巡航速度(km/h)"
            prop="cruise_speed"
            class="number-adjust-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('cruise_speed')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.cruise_speed"
                placeholder="请输入巡航速度"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('cruise_speed')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            label="货舱容积(cm*3)"
            prop="cargo_hold_volume"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('cargo_hold_volume')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.cargo_hold_volume"
                placeholder="请输入货舱容积"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="5"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('cargo_hold_volume')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            label="最大航程(km)"
            prop="max_fly_range"
            class="number-adjust-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('max_fly_range')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.max_fly_range"
                placeholder="请输入最大航程"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('max_fly_range')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            label="飞机长(cm)"
            prop="uav_length"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('uav_length')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.uav_length"
                placeholder="请输入飞机长"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('uav_length')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item prop="need_runway" label="需要跑道">
            <el-select
              v-model="commonForm.need_runway"
              placeholder="请选择"
              popper-class="adminHomeSelect"
            >
              <el-option
                v-for="needRunway in needRunways"
                :key="needRunway.id"
                :label="needRunway.name"
                :value="needRunway.id"
              ></el-option>
            </el-select> </el-form-item
          ><el-form-item
            label="飞机宽(cm)"
            prop="uav_width"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('uav_width')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.uav_width"
                placeholder="请输入飞机宽"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('uav_width')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item prop="land_mode" label="降落模式">
            <el-select
              v-model="commonForm.land_mode"
              placeholder="请选择降落模式"
              popper-class="adminHomeSelect"
            >
              <el-option
                v-for="landMode in landModes"
                :key="landMode.id"
                :label="landMode.name"
                :value="landMode.id"
              ></el-option>
            </el-select> </el-form-item
          ><el-form-item
            label="飞机高(cm)"
            prop="uav_height"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('uav_height')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.uav_height"
                placeholder="请输入飞机高"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('uav_height')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            label="最大航时(min)"
            prop="max_fly_time"
            class="number-adjust-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('max_fly_time')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.max_fly_time"
                placeholder="请输入最大航时"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('max_fly_time')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            prop="uav_type_id"
            label="飞机类型"
            class="left-form-item"
          >
            <el-select
              v-model="commonForm.uav_type_id"
              placeholder="请选择飞机类型"
              popper-class="adminHomeSelect"
            >
              <el-option
                v-for="uavType in uavTypes"
                :key="uavType.id"
                :label="uavType.name"
                :value="uavType.id"
              ></el-option>
            </el-select> </el-form-item
          ><el-form-item prop="company_id" label="所属公司">
            <el-select
              v-model="commonForm.company_id"
              placeholder="请选择所属公司"
              popper-class="adminHomeSelect"
            >
              <el-option
                v-for="company in companys"
                :key="company.id"
                :label="company.name"
                :value="company.id"
              ></el-option>
            </el-select> </el-form-item
          ><el-form-item
            label="货舱长(cm)"
            prop="cargo_hold_length"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('cargo_hold_length')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.cargo_hold_length"
                placeholder="请输入货舱长"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('cargo_hold_length')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            label="飞机图片"
            prop="file"
            class="number-adjust-item right-form-item picture-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 100%; display: block">
              <el-upload
                ref="pictureUpload"
                action="#"
                list-type="picture-card"
                :on-change="changeFile"
                :show-file-list="true"
                :auto-upload="false"
                :class="{ hideUploadBtn: disabledUpload }"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过1M
                </div>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </div> </el-form-item
          ><el-form-item
            label="货舱宽(cm)"
            prop="cargo_hold_widt"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('cargo_hold_widt')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.cargo_hold_widt"
                placeholder="请输入货舱宽"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('cargo_hold_widt')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            label="货仓高(cm)"
            prop="cargo_hold_height"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('cargo_hold_height')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.cargo_hold_height"
                placeholder="请输入货仓高"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('cargo_hold_height')"
              ></el-button>
            </div> </el-form-item
          ><el-form-item
            label="满载航程(km)"
            prop="full_fly_range"
            class="number-adjust-item left-form-item"
            label-width="100px"
          >
            <div style="width: 100%; height: 40px; display: block">
              <el-button
                icon="el-icon-plus"
                @click="addPoint('full_fly_range')"
              ></el-button>
              <el-input
                @keyup.enter.native="submit('commonForm')"
                v-model.number="commonForm.full_fly_range"
                placeholder="请输入满载航程"
                oninput="value=value.replace(/[^\d]/g,'')"
                maxlength="4"
              ></el-input>
              <el-button
                icon="el-icon-minus"
                @click="reducePoint('full_fly_range')"
              ></el-button>
            </div>
          </el-form-item>

          <el-form-item class="formItemBtnRow">
            <el-button
              type="primary"
              @click="submit('commonForm')"
              class="confirmBtn"
              >确 定</el-button
            ><el-button @click="dialogVisible = false" class="cancelBtn"
              >取 消</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "planeType",
  props: ["menuId"],
  data() {
    return {
      queryForm: {},
      title: "添加机型",
      addPermission: null,
      buttonList: [],
      isViewPage: false,
      disabledUpload: false,
      disabled: false,
      options: [],
      addFlag: true,
      commonForm: {},
      current: 1, //当前页数
      size: 6, //显示几条
      totalCount: 0, //总条数
      tableData: [],
      dialogVisible: false,
      dialogImageUrl: "",
      imgDialogVisible: false,
      areas: [],
      rules: {
        name: [{ required: true, message: "请输入飞机型号~", trigger: "blur" }],
        wind_resist_grade: [
          {
            type: "number",
            min: 0,
            max: 17,
            message: "抗风等级在0-17之间~",
          },
        ],
        max_weight: [
          { required: true, message: "起飞重量不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "最大起飞重量在0-1000kg之间~",
          },
        ],
        share_proportion: [
          { trigger: "blur", required: false },
          {
            type: "number",
            min: 1,
            max: 100,
            message: "分成比例在1-100之间~",
          },
        ],
        max_payload: [
          { required: true, message: "最大载荷不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "最大载荷在0-1000kg之间~",
          },
        ],
        uav_ceiling: [
          { required: true, message: "飞机升限不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "飞机升限在0-1000m之间~",
          },
        ],
        start_price: [
          { trigger: "blur", required: false },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "起步价在0-1000万元之间~",
          },
        ],
        max_speed: [
          { required: true, message: "最大飞行速度不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "最大飞行速度在0-1000km/h之间~",
          },
        ],
        price: [
          { trigger: "blur", required: false },
          {
            type: "number",
            min: 0,
            max: 10000,
            message: "价格在0-10000之间~",
          },
        ],
        cruise_speed: [
          { required: true, message: "巡航速度不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "巡航速度在0-1000km/h之间~",
          },
        ],
        cargo_hold_volume: [
          { required: true, message: "货舱容积不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 10000,
            message: "货舱容积在0-10000cm*3之间~",
          },
        ],
        max_fly_range: [
          { trigger: "blur", required: false },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "最大航程在0-1000km之间~",
          },
        ],
        uav_length: [
          { required: true, message: "飞机长不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "飞机长在0-1000cm之间~",
          },
        ],
        need_runway: [
          { required: true, message: "跑道不能为空~", trigger: "blur" },
        ],
        uav_width: [
          { required: true, message: "飞机宽不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "飞机宽在0-1000cm之间~",
          },
        ],
        land_mode: [
          { required: true, message: "降落模式不能为空~", trigger: "blur" },
        ],
        uav_height: [
          { required: true, message: "飞机高不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "飞机高在0-1000cm之间~",
          },
        ],
        max_fly_time: [
          { required: true, message: "最大航时不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 6000,
            message: "最大航时在0-6000min之间~",
          },
        ],
        uav_type_id: [
          { required: true, message: "飞机类型不能为空~", trigger: "blur" },
        ],
        company_id: [
          { required: true, message: "所属公司不能为空~", trigger: "blur" },
        ],
        cargo_hold_length: [
          { required: true, message: "货舱长不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "货舱长在0-1000cm之间~",
          },
        ],
        file: [{ trigger: "blur", required: false }],
        cargo_hold_widt: [
          { required: true, message: "货舱宽不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "货舱宽在0-1000cm之间~",
          },
        ],
        cargo_hold_height: [
          { required: true, message: "货仓高不能为空~", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "货仓高在0-1000cm之间~",
          },
        ],
        full_fly_range: [
          { required: true, trigger: "blur", message: "满载航程不能为空~" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "满载航程在0-1000km之间~",
          },
        ],
      },
      pointRange: {
        wind_resist_grade: { min: 0, max: 17 },
        max_weight: { min: 0, max: 1000 },
        share_proportion: { min: 1, max: 100 },
        max_payload: { min: 0, max: 1000 },
        uav_ceiling: { min: 0, max: 1000 },
        start_price: { min: 0, max: 1000 },
        max_speed: { min: 0, max: 1000 },
        price: { min: 0, max: 10000 },
        cruise_speed: { min: 0, max: 1000 },
        cargo_hold_volume: { min: 0, max: 10000 },
        max_fly_range: { min: 0, max: 1000 },
        uav_length: { min: 0, max: 1000 },
        uav_width: { min: 0, max: 1000 },
        uav_height: { min: 0, max: 1000 },
        max_fly_time: { min: 0, max: 6000 },
        cargo_hold_length: { min: 0, max: 1000 },
        cargo_hold_widt: { min: 0, max: 1000 },
        cargo_hold_height: { min: 0, max: 1000 },
        full_fly_range: { min: 0, max: 1000 },
      },
      needRunways: [
        {
          id: 1,
          name: "需要",
        },
        {
          id: 0,
          name: "不需要",
        },
      ],
      landModes: [
        {
          id: 0,
          name: "滑降",
        },
        {
          id: 1,
          name: "垂直起降",
        },
      ],
      uavTypes: [],
      companys: [],
      type: "image/jpeg,image/png",
    };
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  methods: {
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];

          if (child) {
            if (child.path === "planeType-add") {
              this.addPermission = child;
            } else if (child.path !== "planeType-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    handleChange(selectInfo) {
      if (selectInfo) {
        this.$data.commonForm.station_id = selectInfo[1];
      }
    },
    addPoint(type) {
      this.addOrReducePoint(type, true);
    },
    reducePoint(type) {
      this.addOrReducePoint(type, false);
    },
    add() {
      this.$data.title = "添加机型";
      this.queryAllTypes();
      this.$data.addFlag = true;
      this.$data.dialogVisible = true;
    },
    addUavModel() {
      let vue = this;

      const multiData = this.formatSubmitData();
      this.uploadFileRequest(
        "/basic-info-server/uavmodel/addUavModel.do",
        multiData
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    queryAllTypes() {
      this.queryCompanys();
      this.queryUavTypes();
    },
    queryCompanys() {
      let vue = this;
      this.getRequest("/basic-info-server/company/getAllCompanyList.do")
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.companys = res.data;
            } else {
              this.$data.companys = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    queryUavTypes() {
      let vue = this;
      this.getRequest("/basic-info-server/uavtype/getAllUavTypeList.do")
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (!this.isEmptyArray(res.data)) {
              this.$data.uavTypes = res.data;
            } else {
              this.$data.uavTypes = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    query() {
      let vue = this;
      this.getRequest(
        "/basic-info-server/uavmodel/getUavModelList.do?pagesize=" +
          this.$data.size +
          "&currentpage=" +
          this.$data.current +
          this.getQueryParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑
    edit(row) {
      this.doEdit(row.id);
    },
    doEdit(id) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/uavmodel/getUavModelById.do", {
        id: id,
      })
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              this.$data.title = "修改机型";
              this.queryAllTypes();
              this.$data.addFlag = false;
              this.$data.commonForm = res.data;
              this.$data.dialogVisible = true;
              if (!this.isEmptyStr(res.data.pic_url)) {
                let url = res.data.pic_url;
                if (0 == url.indexOf("/")) {
                  url = "/minio" + url;
                } else {
                  url = "/minio/" + url;
                }
                this.$nextTick(function () {
                  const pictureUpload = vue.$refs.pictureUpload;
                  pictureUpload.clearFiles();
                  this.$data.disabledUpload = true;
                  pictureUpload.$set(pictureUpload.fileList, 0, { url, url });
                });
              }
            } else {
              // let tips =
              //   "<i class='el-icon-warn-tip'></i> 啊哦,请求数据不存在~";
              // this.$confirm(tips, "提示", {
              //   confirmButtonText: "好的",
              //   customClass: "customClass-style",
              //   iconClass: "",
              //   dangerouslyUseHTMLString: true,
              //   confirmButtonClass: "confirm-style",
              //   showCancelButton: false,
              // });
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑提交
    editUavModel() {
      let vue = this;
      const multiData = this.formatSubmitData();
      this.uploadFileRequest(
        "/basic-info-server/uavmodel/upateUavModel.do",
        multiData
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //删除
    del(row) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.doDel(row);
        })
        .catch(() => {});
    },
    doDel(row) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/uavmodel/DelUavModel.do", row)
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            let totalPage = Math.ceil((this.totalCount - 1) / this.size);
            let currentPage =
              this.current > totalPage ? totalPage : this.current;
            this.current = currentPage < 1 ? 1 : currentPage;
            vue.query();
            vue.$message({
              message: "删除成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    view(row) {
      let vue = this;
      this.postJsonRequest("/basic-info-server/uavmodel/getUavModelById.do", {
        id: row.id,
      })
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              vue.$data.title = "查看机型";
              this.queryAllTypes();
              this.$data.addFlag = false;
              this.$data.commonForm = res.data;
              this.$data.isViewPage = true;
              this.$data.dialogVisible = true;
              if (!this.isEmptyStr(res.data.pic_url)) {
                let url = res.data.pic_url;
                if (0 == url.indexOf("/")) {
                  url = "/minio" + url;
                } else {
                  url = "/minio/" + url;
                }
                this.$nextTick(function () {
                  const pictureUpload = vue.$refs.pictureUpload;
                  pictureUpload.clearFiles();
                  this.$data.disabledUpload = true;
                  pictureUpload.$set(pictureUpload.fileList, 0, { url, url });
                });
              }
            } else {
              // let tips =
              //   "<i class='el-icon-warn-tip'></i> 啊哦,请求数据不存在~";
              // this.$confirm(tips, "提示", {
              //   confirmButtonText: "好的",
              //   customClass: "customClass-style",
              //   iconClass: "",
              //   dangerouslyUseHTMLString: true,
              //   confirmButtonClass: "confirm-style",
              //   showCancelButton: false,
              // });
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //分页函数
    handleSizeChange: function (val) {
      this.size = val;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.$data.addFlag) {
          this.addUavModel();
        } else if (valid && !this.$data.addFlag) {
          this.editUavModel();
        } else {
          return false;
        }
      });
    },
    formatterTemp(row, column, value) {
      return this.$data.temps[value].name;
    },
    changeFile(file, fileList) {
      if (file) {
        let fileType = this.$data.type.split(",");
        if (fileType.indexOf(file.raw.type) >= 0) {
          if (1048576 < file.size) {
            this.$refs.pictureUpload.clearFiles();
            this.$nextTick(function () {
              this.$data.disabledUpload = false;
              this.$data.uploadFile = null;
            });

            //提示消息
             let tips = "<i class='el-icon-warn-tip'></i>" + "文件大小不能超过1M";
             this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
            return;
          }
          this.$data.uploadFile = file;
          this.$data.disabledUpload = true;
        } else {
          fileList.splice(fileList.length - 1, 1);
          this.$message({
            message: "请选择文件类型为:" + this.$data.type,
            type: "error",
          });
        }
      }
    },
    handleRemove(file, fileList) {
      this.$refs.pictureUpload.clearFiles();
      this.$nextTick(function () {
        this.$data.disabledUpload = false;
        this.$data.uploadFile = null;
        this.$data.commonForm.pic_url = null;
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    formatSubmitData() {
      const formData = new FormData();
      const commonForm = this.$data.commonForm;
      for (const key in commonForm) {
        if (commonForm.hasOwnProperty(key)) {
          const element = commonForm[key];
          if (null != element && 0 < (element + "").trim().length) {
            formData.append(key, element);
          }
        }
      }
      if (this.$data.uploadFile) {
        formData.append("pic", this.$data.uploadFile.raw);
      }
      return formData;
    },
  },
  watch: {
    dialogVisible: function (nval, oval) {
      if (!nval) {
        this.$data.isViewPage = false;
        this.$data.commonForm = {};
        this.$refs.pictureUpload.clearFiles();
        this.$data.disabledUpload = false;
      }
      this.defaultClearValidate();
    },
  },
};
</script>

<style scoped>
.mainCommonListContainer {
  width: 100%;
  height: 100%;
}
</style>
<style>
.adminHomeContainer
  .el-tabs
  .el-tabs__content
  #pane-planeType
  .commonDialog
  .el-dialog {
  margin-top: calc(25% - 312px) !important;
}
.adminHomeContainer
  .el-tabs
  .el-tabs__content
  .commonScrollDialog
  .el-dialog
  .el-dialog__body
  .el-form
  .picture-form-item
  .el-form-item__content
  .el-upload-list--picture-card.is-disabled
  .el-upload-list__item-actions
  .el-upload-list__item-delete,
.adminHomeContainer
  .el-tabs
  .el-tabs__content
  .commonScrollDialog
  .el-dialog
  .el-dialog__body
  .el-form
  .formItemBtnRow
  button.el-button.is-disabled {
  display: none !important;
}
.el-dialog .el-dialog__body .scrollContainer {
  height: 585px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/plane/model/model.vue